import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import IndexRepository from '../../Index/Repositories/IndexRepository'


class CreateBloc {

    createChannel = new Subject();
    checkChannel = new Subject();
    repository = new IndexRepository()

    constructor() {
        this.createChannel.next({status: apiResponse.INITIAL})
    }

    fetchCreate = async (query) => {
        try {
            this.createChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchCreate(query).then((result) => {
                this.createChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.createChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }
    fetchCheck = async (query) => {
        try {
            this.checkChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchCheck(query).then((result) => {
                this.checkChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.checkChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }

}

export default CreateBloc